/**
 * Defines the events associated with the Button component.
 */
export const ButtonEvents = {
  CLICK: 'luds-button:click',
} as const;

/**
 * Defines the variants for the Button component.
 */
export type ButtonVariants = 'primary' | 'secondary' | 'flat' | 'ghost' | 'ghost-inverse' | 'secondary-inverse';

/**
 * Defines the sizes for the Button component.
 */
export type ButtonSizes = 'extra-small' | 'small' | 'large';
